import { env } from "@/env"

const getQueryArgs = function(url){
    if(typeof url != "string"){
        return {};
    }
    url = url.substring(url.indexOf("?")+1);

    var ps = url.split(/&|=/);
    var params = {};
    for(var i=0;i<ps.length;i+=2){
        params[ps[i]] = ps[i+1];
    }

    return params;
}

/**
 * [addQueryArgs 给url添加参数,参数会加在hash值前边
 * @param {[string]} url      [需添加参数的url]
 * @param {[object]} paramObj [需添加的参数,hash键值对形式]
 */
const addQueryArgs = function(url, paramObj) {
    var result;
    var key, value;
    var pathUrl = url.split("#")[0]
    const hashParam = url.split("#")[1] ? "#" + url.split("#")[1] : ''

    for (key in paramObj) {
        value = paramObj[key];
        result = new RegExp("(" + key + "=)[^&]+", "i");
        if (pathUrl.match(result)) {
            pathUrl = pathUrl.replace(result, "$1" + value);
        } else {
            pathUrl += (pathUrl.indexOf('?') === -1) ?
                ('?' + key + '=' + value) : ('&' + key + '=' + value);
        }
    }
    return pathUrl + hashParam;
}

export { getQueryArgs, addQueryArgs }